import * as ActionTypes from './actionTypes';

export const updateFilterField = (field, value) => {
  return {
  type: ActionTypes.UPDATE_FILTER_FIELD,
  field,
  value
};};

export const clearFilters = () => ({
  type: ActionTypes.CLEAR_FILTERS
});
export const updateData = (data) => ({
  type: ActionTypes.UPDATE_DATA,
  data
});

export const totalDocCount = (totalDocCount) => ({
  type: ActionTypes.TOTAL_DOC_COUNT,
  totalDocCount
});

export const filterData = (filterData) =>  {
  return {
  type: ActionTypes.FILTER_DATA,
  filterData,
};};

export const allWebURLData = (webURLs) => ({
  type: ActionTypes.ALL_WEB_URL_DATA,
  value:webURLs,
});

export const defaultFilters = (defaultDropdownOptions) => {
  return {
  type: ActionTypes.DEFAULT_FILTERS,
  defaultDropdownOptions
};};
